import styled from 'styled-components';
import { resolveStyledSpacings } from '../../../styles/spacings/resolve-styled-spacings';
import { Spacings } from '../../../styles/spacings/Spacings';

export const Wrapper = styled.div<Spacings>`
  ${(p) => resolveStyledSpacings(p)}
`;
